import React from 'react';
import PriceLabel from '@prisjakt/ui-price-label';
import ShippingLabel from '@prisjakt/ui-shipping-label';
import InternationalPriceLabel from '@prisjakt/ui-international-price-label';
import shallowEqual from 'shallowequal';

import { PricePrice } from '../../../../types';
import { Align } from '../../types';

import * as S from './styles';

type OwnProps = {
  price: PricePrice;
  storeIsFeatured?: boolean | null;
  campaignStyling?: string;
  isInternationalPrice?: boolean | null;
  align?: Align;
};

const PriceColumn = React.memo(
  ({
    price,
    storeIsFeatured,
    isInternationalPrice,
    campaignStyling,
    align,
  }: OwnProps) => (
    <S.PriceColumn align={align}>
      {price.exclShipping && (
        <PriceLabel
          value={price.exclShipping}
          styling={storeIsFeatured ? 'primary' : 'lighten'}
          campaignStyling={campaignStyling}
          medium
        />
      )}
      <S.HideOnMobile>
        {price.inclShipping && (
          <>
            <S.Hidden>&nbsp;(</S.Hidden>
            {price.exclShipping && (
              <ShippingLabel
                toneDown
                exclShipping={price.exclShipping}
                inclShipping={price.inclShipping}
              />
            )}

            <S.Hidden>)</S.Hidden>
          </>
        )}
        {price.inclShipping && isInternationalPrice && (
          <InternationalPriceLabel
            currency={price.originalCurrency!}
            value={price.originalCurrencyExclShipping!}
            toneDown={!storeIsFeatured}
          />
        )}
      </S.HideOnMobile>
    </S.PriceColumn>
  ),
  (prevProps, nextProps) => {
    const { price: prevPrice, ...prevRest } = prevProps;
    const { price: nextPrice, ...nextRest } = nextProps;
    return (
      shallowEqual(prevPrice, nextPrice) && shallowEqual(prevRest, nextRest)
    );
  }
);

export default PriceColumn;
